import axiosInstance from 'api/axios'
import { PublicConfig, Response } from 'types'

/**
 * `/config/public` answers with its payload inside an extra `data` envelope, while every other
 * endpoint in the API returns it bare — `Response<T>` here describes what axios wraps, not what the
 * backend sends. Both shapes are accepted so this keeps working if the backend drops the envelope.
 */
type PublicConfigBody = PublicConfig | Response<PublicConfig>

/** Anonymous — called on the registration pages before the user has a token. */
export const getPublicConfig = async (): Promise<PublicConfig> => {
  const { data } = await axiosInstance.post<unknown, Response<PublicConfigBody>>(
    '/config/public',
    {},
  )

  return 'plans' in data ? data : data.data
}
